export const environment = {
    production: false,
    authority: 'https://zcbbauthprod.ciamlogin.com/zcbbauthprod.onmicrosoft.com',
    clientId: 'b6c5ef7c-d5da-44f4-930b-1aca02342793',
    redirectUri: '/',
    postLogoutRedirectUri: '/',
    apiUrl: 'https://wa-zack-basktball-prod-cus01-abekfegkgebugncs.centralus-01.azurewebsites.net',         
    currentCompetition: 41097,
    apiScope: 'api://57d71ca1-c52c-4821-9acd-03351f4bd322/CBBPRODAPI',
    msalConfig: {
        auth: {
            clientId: 'b6c5ef7c-d5da-44f4-930b-1aca02342793',
        }
    },
    apiConfig: {
        scopes: ['api://57d71ca1-c52c-4821-9acd-03351f4bd322/CBBPRODAPI'],
        uri: 'api://57d71ca1-c52c-4821-9acd-03351f4bd322'
    },
    authorityDomain: 'zcbbauthprod.ciamlogin.com'
};
